import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';

import AudioPlayer from 'components/AudioPlayer';
import isIpadDevice from 'utils/isIpadDevice';
import previewVideoNo from './assets/no_skrivhastighet_video.mp4';
import previewVideoNn from './assets/nn_skrivhastighet_video.mp4';

import previewNormingLower from './assets/previewNormingLower.mp4';
import previewNormingUpper from './assets/previewNormingUpper.mp4';

import dataNo from './languages/no-data.json';
import dataNn from './languages/nn-data.json';


import audioNo from 'assets/sounds/no/4 1 Skrivehastighet Intro.mp3';
import audioNn from 'assets/sounds/nn/4 1 Skrivehastighet Intro.mp3';


import audioNoLower from 'assets/sounds/no/WEF-norming-Intro-lower.mp3';
import audioNoUpper from 'assets/sounds/no/WEF-norming-Intro-upper.mp3';

import audioNnLower from 'assets/sounds/nn/WEF-norming-Intro-lower.mp3';
import audioNnUpper from 'assets/sounds/nn/WEF-norming-Intro-upper.mp3';
import dataNnNorming from './languages/nn-data-norming.json';
import dataNoNorming from './languages/no-data-norming.json';


const dataObj = {
	no: {data: dataNo, audio: audioNo, video: previewVideoNo},
	nn: {data: dataNn, audio: audioNn, video: previewVideoNn},
};


const normingDataObj = {
	no: {data: dataNoNorming, audioLower: audioNoLower, audioUpper:audioNoUpper, video: previewVideoNo},
	nn: {data: dataNnNorming, audioLower: audioNnLower, audioUpper:audioNnUpper, video: previewVideoNo},
};

const pickNormingVideo = (grade) => {
  const g = Number(grade);
  if (!Number.isFinite(g) || g < 2 || g > 7) {
	return null;
}
  return g <= 4 ? previewNormingLower : previewNormingUpper;
};

const pickNormingAudio = (assets,grade) => {
  const g = Number(grade);
  if (!Number.isFinite(g) || g < 2 || g > 7) {
	return null;
}
  return g <= 4 ? assets.audioLower : assets.audioUpper;
};


class Intro extends React.Component {
	constructor(props) {
		super(props);
		const grade = Number(this.props.candidateGrade);
		
		const assets = this.props.isDldTest ? normingDataObj[strings.getLanguage()] : dataObj[strings.getLanguage()];
	
		this.audio = this.props.isDldTest ? pickNormingAudio(assets,grade): assets.audio;

		this.skrivehastighetIntro = this.props.isDldTest ? strings.skrivehastighetIntroNorming:strings.skrivehastighetIntro;
		this.skrivehastighetIntro2 = this.props.isDldTest ? strings.skrivehastighetIntro2Norming:strings.skrivehastighetIntro2;
		this.text = this.props.isDldTest? assets.data[grade].value : assets.data[0].value;
		this.video = this.props.isDldTest ? (pickNormingVideo(grade) ?? assets.video): assets.video;

		this.audioRefView = React.createRef();
		this.videoRefreview = React.createRef();
		this.isIpad = isIpadDevice();
	}

	render() {
		const {onNextStep} = this.props;

		let videoRef;

		return (
			<div className={this.isIpad ? 'lit-preview-btn-fix' : ''}>
				<p className= {this.props.isDldTest ? "text-center":"text-left"}>
					<AudioPlayer
						autoplay
						inline
						onErrorPlay={()=>{
							console.log('Something went wrong');
						}}
						onPause={() => {
							videoRef.play();
							if (this.videoRefreview.current) {
																		this.videoRefreview.current.scrollIntoView(
																			{
																				behavior:
																					'smooth',
																				block: 'start',
																			}
																		);
																	}
						}}
						src={this.audio}
						
					/>
					{this.skrivehastighetIntro}
				</p>
				<div className="tutorial-text">
					<h3 className="text">
						<strong>{this.text}</strong>
					</h3>
				</div>
				<p>{this.skrivehastighetIntro2}</p>

				<div className="lit-preview" ref={this.videoRefreview}>
					<p className="lit-preview__label">
						{strings.testLooksLikeThis}
					</p>
					<video
						className="lit-preview__video"
						loop
						onClick={() => {
							videoRef.play();
						}}
						ref={(ref) => {
							videoRef = ref;
						}}
						src={this.video}
					/>
				</div>

				<p>{strings.skrivehastighetHint}</p>

				<button
					className="lit-btn bg-primary"
					onClick={() => onNextStep()}
				>
					{strings.start}
				</button>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {candidateGrade} = state;
	return {
		candidateGrade,
	};
};
export default connect(mapStateToProps)(Intro);
